<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="商品配置"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="api.list"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          <el-form-item label="名称">
            <el-input v-model="params.SettingName" placeholder="请输入名称" clearable />
          </el-form-item>
                    
        </template>
        <template slot="table">
          <el-table-column prop="SettingName" label="名称" align="center" width="200" />
          <el-table-column prop="SettingType" label="类型" >
            <template slot-scope="{row}">
              {{row.SettingType==1?"不支持无理由退货":"支持无理由退货"}}
            </template>
          </el-table-column>
         
          <el-table-column prop="SettingDay" label="退货期限">
        </el-table-column>   
          <el-table-column prop="DeliveryTime" label="自动收货期限">
        </el-table-column>     
        
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
        api: require("@/api/sy/goodssetting").default,
        params: {
          CountryName: "",
       
        },
      };
    },
    methods: {
      delRange(ids) {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
  </script>